import * as React from "react"
import IndexLayout from "~layouts/IndexLayout"
import Head from "~components/Head"
import SampleCodeCatalog from "../components/SampleCodeCatalog"

const SampleCodeApp = ({ pageContext, location }) => (
  <IndexLayout>
    <Head title="Box Sample Code Catalog" />
    <SampleCodeCatalog location={location} />
  </IndexLayout>
)

export default SampleCodeApp
